<template>
  <section class="is-small">
    <div class="container">
      <ui-page-hero
        id="id_title_channel"
        :title="'Invoices'"
      />

      <Invoices />
    </div>
  </section>
</template>

<script>

const Invoices = () => import('@/components/FeeInvoices/Invoices')

export default {
  components: {
    Invoices,
  },

  props: {},

  data() {
    return {}
  },

  computed: {},

  watch: {},

  created() { },

  mounted() { },

  beforeDestroy() { },

  methods: {},
}
</script>
